// src/constants/helpPages.js
export const HELP_PAGE_KEYS = {
  '/integrators': 'integrators',
  '/company': 'company',
  '/employees': 'employees',
  '/users': 'users',
  '/resources/layers': 'layers',
  '/object': 'objects',
  '/remote-objects': 'remote_objects',
  '/terminals': 'terminals',
  '/invoices': 'invoices',
}

export const HELP_SETTINGS_KEY = 'adminpanel_help'

export function getHelpKeyFromRoute(route) {
  const match = Object.entries(HELP_PAGE_KEYS).find(([path]) =>
    route.path === path || route.path.startsWith(path + '/')
  )
  return match?.[1] ?? null
}

export function parseHelpSettings(value) {
  try {
    const parsed = JSON.parse(value || '{}')
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}